/**
 * @created on 2017/9/25
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import './css/share.scss'
import 'social-share.js/dist/js/social-share.min'
import { loadScript } from '../../libs/utils/index'

let UA = window.navigator.userAgent

// 微信环境调用JSSDK
if (
  UA.toUpperCase().indexOf('MICROMESSENGER') !== -1 &&
  window.baseInfo &&
  window.baseInfo.wx_config
) {
  loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', wxShareInit.bind(this))
}

function wxShareInit() {
  var wx_config = window.baseInfo.wx_config

  var _config = {
    debug: wx_config.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: wx_config.appId, // 必填，公众号的唯一标识
    timestamp: wx_config.timestamp, // 必填，生成签名的时间戳
    nonceStr: wx_config.nonceStr, // 必填，生成签名的随机串
    signature: wx_config.signature, // 必填，签名，见附录1
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone',
      'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
      'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  }

  // 微信基本配置信息
  wx.config(_config)

  var shareInfo = document.title
  var shareDesc = document
    .querySelector('meta[name="description"]')
    .getAttribute('content')
  var shareImgUrl = wx_config.image
  var shareUrl =
    window.location.href.replace('.xinli001.com', '.xinli001.xin') +
    '?is_share=1&sharetype=mobile'

  wx.ready(function() {
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: shareInfo, // 分享标题
      link: shareUrl, // 分享链接
      desc: shareDesc,
      imgUrl: shareImgUrl, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    })

    // 分享给朋友
    wx.onMenuShareAppMessage({
      title: shareInfo, // 分享标题
      link: shareUrl, // 分享链接
      desc: shareDesc,
      imgUrl: shareImgUrl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    })

    // 分享到qq
    wx.onMenuShareQQ({
      title: shareInfo, // 分享标题
      link: shareUrl, // 分享链接
      desc: shareDesc,
      imgUrl: shareImgUrl, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    })

    // 分享到腾讯微博
    wx.onMenuShareWeibo({
      title: shareInfo, // 分享标题
      link: shareUrl, // 分享链接
      desc: shareDesc,
      imgUrl: shareImgUrl, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    })

    // 分享到qq空间
    wx.onMenuShareQZone({
      title: shareInfo, // 分享标题
      link: shareUrl, // 分享链接
      desc: shareDesc,
      imgUrl: shareImgUrl, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    })
    wx.updateAppMessageShareData({
      title: shareInfo, // 分享标题
      link: shareUrl, // 分享链接
      desc: shareDesc,
      imgUrl: shareImgUrl, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    })
    wx.updateTimelineShareData({
      title: shareInfo, // 分享标题
      link: shareUrl, // 分享链接
      desc: shareDesc,
      imgUrl: shareImgUrl, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    })
  })
}

export default class Share {
  constructor(
    ops = {
      url: window.location.href,
      title: document.title,
      content: '壹心理',
      cover: document.querySelector('img').src
    }
  ) {
    this.$shareModal = document.createElement('div')

    this.$shareModal.className = 'share-modal'

    this.$shareModal.innerHTML =
      '<a href="javascript:;" class="social-share-icon yxl-font yxl-font-icon_link icon-link"></a>'

    let $gblHeader = document.querySelector('.global-header')
    let offsetTop = '0'

    // 回调，主要用于埋点统计和debug，输出选择的分享渠道
    this.cb = ops.callback

    let $config = {
      url: ops.url,
      source: '',
      title: ops.title,
      description: ops.content,
      image: ops.cover, // 图片, 默认取网页中第一个img标签
      sites: ['wechat', 'qzone', 'qq', 'weibo'], // 启用的站点
      wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
      wechatQrcodeHelper:
        '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>'
    }

    // if ($gblHeader) {
    //   offsetTop = `${$gblHeader.offsetHeight}px`;
    // } else {
    offsetTop = '1.173333rem'
    // }

    this.$shareModal.style.top = offsetTop

    document.body.insertBefore(
      this.$shareModal,
      document.body.firstElementChild
    )

    this.$shareModal
      .querySelector('.icon-link')
      .addEventListener('click', function(e) {
        e.preventDefault()

        var selection = window.getSelection() // Save the selection.
        var range = document.createRange()
        var $url = document.createElement('div')

        $url.display = 'none'
        $url.innerHTML = $config.url

        document.body.appendChild($url)

        range.selectNodeContents($url)
        selection.removeAllRanges() // Remove all ranges from the selection.
        selection.addRange(range) // Add the new range.

        document.execCommand('copy')

        selection = null
        range = null
        document.body.removeChild($url)

        if (window.toast) {
          window.toast('复制链接成功')
        } else {
          alert('复制链接成功')
        }
      })

    socialShare('.share-modal', $config)

    this.$shareModal.addEventListener('click', this.clickEvent.bind(this), true)
  }

  clickEvent(e) {
    let target = e.target

    while (target !== this.$shareModal) {
      if (target.tagName.toUpperCase() === 'A') {
        // 寻找关键字
        let keyword = target.className.match(/icon\-\w*\b/)[0]

        // 获取渠道
        let channel = keyword.split('-')[1]

        // 微信渠道
        if (channel === 'wechat') {
          if (target.classList.toggle('active')) {
            target.querySelector('.wechat-qrcode').style.display = 'block'
          } else {
            target.querySelector('.wechat-qrcode').style.display = ''
          }

          channel = 'wechat'
        }

        this.cb && this.cb(channel)

        break
      }

      target = target.parentNode
    }
  }

  show() {
    this.$shareModal.classList.add('show')
  }

  hide() {
    let $wechatBtn = this.$shareModal.querySelector('.icon-wechat')

    // 由于在微信环境下无法收起问题
    if ($wechatBtn) {
      $wechatBtn.querySelector('.wechat-qrcode').style.display = ''
      $wechatBtn.classList.remove('active')
    }

    this.$shareModal.classList.remove('show')
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/Share/index.js